module.exports = __webpack_public_path__ + "static/media/ManorRuin-Selected.fdef6653.svg";